import React from "react";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
import DepositsCard from "../deposits";

export default function DepositGridItem({ dataSource = [] }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="row px-2">
        {dataSource.length === 0 ? (
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        ) : (
          <>
            <div className="ft-table">
              <table className="table " style={{ cursor: "pointer" }}>
                <thead style={{ backgroundColor: "#F1F1F1" }}>
                  <tr>
                    <th>
                      {t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                    </th>

                    <th>{t("common.amount", { defaultValue: "Amount" })}</th>
                    <th>{t("pages.accounts.deposits.deposit_type", {
                        defaultValue: "Deposit Type",
                      })}</th>
                    <th>
                      {t("pages.pending_approval.Initiated_Date", {
                        defaultValue: "Initiated Date",
                      })}
                    </th>
                    <th>{t("common.status", { defaultValue: "Status" })}</th>
                  </tr>
                </thead>
                <tbody>
                  {dataSource.map((option, index) => (
                    <DepositsCard record={option} />
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
}
